export enum GoodsSizeType {
  DIMENSIONS = 'dimensions',
  LOADING_METERS = 'loading-meters',
  VOLUME = 'volume',
}
